import React, { useEffect, useState, useContext, useRef } from 'react'
import "./CompanyDetail.css"
import { useParams } from 'react-router-dom'
import { viewCompany } from '../Network/Company'
import { Row, Col, Table, Button, Form, Pagination, Spinner } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faTrash, faUserCircle, faProjectDiagram, faPen, faWindowMaximize } from '@fortawesome/free-solid-svg-icons'
import { NotifyContext } from '../Library/Notify'
import { LanguageContext } from '../Language/LanguageContext'
import { TablePagination, HeaderTitle, TabButton, Checkbox } from '../Library'
import { listDepartment, addDepartment, removeDepartment } from '../Network/Department'
import { updateCompany } from '../Network/Company'
import { listUser } from '../Network/User'
import { setDocumentTitle } from '../AppTitle'
import { RoleContext } from '../Role/RoleContext'
import { listFloor } from '../Network/Floor'
import axios from 'axios'

function CompanyDetail() {
    const { id } = useParams()
    const roleCx = useContext(RoleContext)
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.company
    const notify = useContext(NotifyContext)
    const [title, setTitle] = useState("");
    const [isLoadLeft, setLoadLeft] = useState(false)
    const [company, setCompany] = useState("");
    const [companyEn, setCompanyEn] = useState("")
    const [acronym, setAcronym] = useState("");
    const [branch, setBranch] = useState("");
    const [branchCode, setBranchCode] = useState("");
    const [location, setLocation] = useState("");
    const [officePhone, setOfficePhone] = useState("");
    const [type, setType] = useState("OFFICE")
    const [floor, setFloor] = useState(false)
    const [isInformation, setIsInformation] = useState(false)
    const [isError, setError] = useState(false);
    const hiddenFileInput = useRef(null);
    const [logoImage, setLogoImage] = useState({preview: "", raw: "" }); 

    const typeList = [
        { value: "OFFICE", label: lang.office },
        { value: "RETAIL", label: lang.retail }
    ]
    const [floorList, setFloorList] = useState([])

    const [menu, setMenu] = useState("Department");

    const fetchData = () =>{
        setLoadLeft(true)
        viewCompany(id,
            (data)=>{
                setDocumentTitle(data.name)
                setTitle(data.name);
                setCompany(data.name);
                setCompanyEn(data.nameEn)
                setAcronym(data.acronym);
                setBranch(data.branch);
                setBranchCode(data.branchCode);
                setLocation(data.location)
                setOfficePhone(data.officePhone)
                if(data.type !== null){
                    setType(data.type)
                }else{
                    setType("OFFICE")
                }
                setFloor(data.floorId)
                setIsInformation(data.isInformationScreen)
                setLoadLeft(false)
            },
            (error)=>{
                setLoadLeft(false)
                notify.showNotify("Something wrong", error.message, 2)
            })
    }

    const onUpdate = () =>{
        if(!company || !companyEn || !acronym || !branch || !branchCode || !location || !officePhone){
            notify.showNotify(lang.not_complete, lang.not_complete_desc, 1);
            setError(true);
            return;
        }

        setLoadLeft(true)
        updateCompany(id, company, companyEn, acronym, branch, branchCode, location, officePhone, type, floor, isInformation,
            async ()=>{
                if(logoImage.raw)
                {
                    const formData = new FormData();
                    formData.append("store_id", id);
                    formData.append("image", logoImage.raw);
                    const responseData = await axios.post('https://wtc.co.th:8080/update_storelogo', formData);
                    console.log(responseData);
                }
                notify.showNotify(lang.updated_company, lang.updated_company_desc, 0)
                fetchData()
            },
            (error)=>{
                setLoadLeft(false)
                notify.showNotify("Something wrong", error.message, 2)
            })
    }

    const handleRetail = () => {
        hiddenFileInput.current.click();
    };

    const handleChangeRetail = (event) => {
        setLogoImage({
            preview: URL.createObjectURL(event.target.files[0]),
            raw: event.target.files[0]
          });
        console.log(event.target.files[0]);
    };

    useEffect( async ()=>{
        const fetchFloorList = () => {
            listFloor(
                (data) => {
                    setFloorList(data)
                },
                (error) => {  }
            )
        }
        fetchFloorList()
        fetchData()
        if(type == 'RETAIL'){
            console.log('RETAIL')
            const formData = new FormData();
            formData.append('store_id', id);
            await axios.post('https://wtc.co.th:8080/get_storelogo',formData,{ timeout: 3000 }).then(function (responseData) {
                console.log(responseData)
                setLogoImage({
                    preview: responseData.data
                })
            }).catch(function (error) {
                console.log(error);
            });
        }else{
            console.log('OFFICE')
        }
    },[])

    return (
        <div id="company-detail">
            <div className="header-content">
                <HeaderTitle
                    title={title}
                    isShowBack
                    backTo="/company"
                />
                {
                    type == 'RETAIL'?
                    <div>
                        <Button type='file' variant="success" style={{fontSize:'20px'}} disabled={type=='RETAIL'?false:true} onClick={handleRetail} >เพิ่มโลโก้ร้านค้า</Button>
                        <input type='file' accept='image/*'  style={{display:'none'}} ref={hiddenFileInput} onChange={handleChangeRetail}/>
                    </div>
                    :null
                }
                
            </div>
            <Row>
                <Col lg={6} style={{ marginBottom: 20 }}>
                    <div className="menu-container">
                        <div style={{display: "flex"}}>
                        <TabButton
                        linkButton={false}
                        title={lang.department}
                        icon={faProjectDiagram}
                        isSelected={menu === "Department" ? true:false}
                        onClick={()=>setMenu("Department")}
                        />
                        <TabButton
                        linkButton={false}
                        title={lang.edit_company}
                        icon={faPen}
                        isSelected={menu === "Edit" ? true:false}
                        onClick={()=>setMenu("Edit")}
                        />
                        </div>
                        <div>
                            { isLoadLeft ?
                            <Spinner
                            variant="primary" 
                            animation="border"
                            /> : null
                            }
                        </div>
                    </div>
                    <div className="menu-detail-container">
                        { menu === "Department" ?
                        <div>
                            <DepartmentSection
                            companyId={id}
                            loadCallback={(load)=>setLoadLeft(load)}
                            />
                        </div>
                        : null
                        }
                        { menu === "Edit" ?
                        <div>
                            <Form
                            onSubmit={(e)=>{
                                e.preventDefault();
                                onUpdate();
                            }}
                            >
                                <Form.Group>
                                    <Form.Group>
                                        <Form.Label>{lang.company_name}</Form.Label>
                                        <Form.Control
                                        value={company}
                                        isInvalid={isError && !company}
                                        onChange={(e)=>setCompany(e.target.value)}
                                        />
                                    </Form.Group>
                                    <Form.Group>
                                        <Form.Label>{lang.company_name_en}</Form.Label>
                                        <Form.Control
                                        value={companyEn}
                                        isInvalid={isError && !companyEn}
                                        onChange={(e)=>setCompanyEn(e.target.value)}
                                        />
                                    </Form.Group>
                                    <Form.Group>
                                        <Form.Label>{lang.acronym}</Form.Label>
                                        <Form.Control
                                        value={acronym}
                                        isInvalid={isError && !acronym}
                                        onChange={(e)=>setAcronym(e.target.value)}
                                        />
                                    </Form.Group>
                                    <Form.Group>
                                        <Form.Label>{lang.branch}</Form.Label>
                                        <Form.Control
                                        value={branch}
                                        isInvalid={isError && !branch}
                                        onChange={(e)=>setBranch(e.target.value)}
                                        />
                                    </Form.Group>
                                    <Form.Group>
                                        <Form.Label>{lang.branch_code}</Form.Label>
                                        <Form.Control
                                        value={branchCode}
                                        isInvalid={isError && !branchCode}
                                        onChange={(e)=>setBranchCode(e.target.value)}
                                        />
                                    </Form.Group>
                                    <Form.Group>
                                        <Form.Label>{lang.location}</Form.Label>
                                        <Form.Control
                                        value={location}
                                        isInvalid={isError && !location}
                                        onChange={(e)=>setLocation(e.target.value)}
                                        />
                                    </Form.Group>
                                    <Form.Group>
                                        <Form.Label>{lang.office_phone}</Form.Label>
                                        <Form.Control
                                        value={officePhone}
                                        isInvalid={isError && !officePhone}
                                        onChange={(e)=>setOfficePhone(e.target.value)}
                                        />
                                    </Form.Group>
                                </Form.Group>
                                <Form.Group>
                            <Form.Label>{lang.type}</Form.Label>
                            <Form.Control 
                            as="select"
                            value={type}
                            onChange={(e)=>setType(e.target.value)}
                            >
                                { typeList.map((item, key) =>
                                <option value={item.value} key={key}>{item.label}</option>
                                )}
                            </Form.Control>
                            </Form.Group>
                            <Form.Group>
                                <Form.Label>{`${lang.floor} (${lang.optional})`}</Form.Label>
                                <Form.Control 
                                as="select"
                                value={floor ? floor: ""}
                                onChange={(e)=>setFloor(e.target.value)}>
                                    <option value="">{lang.select_floor}</option>
                                    { floorList.map((item, key) =>
                                    <option value={item.id} key={key}>{item.floorName}</option>
                                    )}
                                </Form.Control>
                            </Form.Group>
                            { roleCx.checkPermission('_MENU_', 'app.front_screen') ?
                            <Form.Group>
                                <Checkbox
                                checked={isInformation}
                                onChange={()=>setIsInformation(!isInformation ? true : false)} 
                                label={
                                    <div className='optional-checkbox'>
                                        <FontAwesomeIcon icon={faWindowMaximize} className='icon'/>
                                        <div>
                                            <div className="title"><b>{lang.display_on_information_screen}</b></div>
                                            <div className="desc">{lang.display_on_information_screen_desc}</div>
                                        </div>
                                    </div>
                                    
                                }/>
                            </Form.Group>
                            : null
                            }
                            { type == 'RETAIL'?
                            <Form.Group>
                                <div>
                                    <div className='header-preview-retail'>ตัวอย่างโลโก้ร้านค้า</div>
                                    <img className='img-preview-retail' src={logoImage.preview}/>
                                </div>
                            </Form.Group>:null
                            }
                                <hr/>
                                <Button
                                type="submit"
                                >
                                    {lang.save_change}
                                </Button>
                            </Form>
                        </div>
                        : null
                        }
                    </div>
                </Col>
                <Col lg={6}>
                    <ListUser
                    companyId={id}
                    />
                </Col>
            </Row>
            
        </div>
    )
}

function DepartmentSection(props){
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.company
    const [departmentList, setDepartmentList] = useState([]);
    const [departmentName, setDepartmentName] = useState("");
    const notify = useContext(NotifyContext)

    const fetchData = () =>{
        props.loadCallback(true);
        listDepartment(props.companyId,
            (data)=>{
                props.loadCallback(false);
                setDepartmentList(data)
            },
            (error)=>{
                props.loadCallback(false);
                notify.showNotify("Something wrong", error.message, 2)
            })
    }

    const addDepart = () =>{
        if(!departmentName) { return; }
        props.loadCallback(true);
        addDepartment(departmentName, props.companyId,
            ()=>{
                setDepartmentName("")
                fetchData()
            },
            (error)=>{
                props.loadCallback(false);
                notify.showNotify("Something wrong", error.message, 2)
            })
    }

    const removeDepart = (id) =>{
        if(window.confirm(lang.delete_depart_sure)){
            props.loadCallback(true);
            removeDepartment(id,
                ()=>{
                    props.loadCallback(false);
                    fetchData()
                },
                (error)=>{
                    props.loadCallback(false);
                    notify.showNotify("Something wrong", error.message, 2)
                })
        }
    }

    useEffect(()=>{
        fetchData()
    },[])

    return(
        <div>
            <div className="add-department">
                <Form.Control
                placeholder={lang.enter_department}
                style={{marginRight: 10}}
                value={departmentName}
                onChange={(e)=>setDepartmentName(e.target.value)}
                />
                <Button
                variant="success"
                onClick={()=>addDepart()}
                >
                    <FontAwesomeIcon icon={faPlus} size="sm"/>
                </Button>
            </div>
            <div className="department-table company-section">
                <Table hover>
                    <thead>
                        <tr>
                            <th>{lang.department}</th>
                            <th>{lang.action}</th>
                        </tr>
                    </thead>
                    <tbody>
                        { departmentList.map((item, key)=>
                        <tr key={key}>
                            <td>{item.name}</td>
                            <td>
                                <Button size="sm" variant="danger"
                                onClick={()=>removeDepart(item.id)}>
                                    <FontAwesomeIcon icon={faTrash}/>
                                </Button>
                            </td>
                        </tr>
                        )}
                        { departmentList.length === 0 ?
                        <tr>
                            <td colSpan={2} style={{textAlign: 'center'}}>
                                {lang.no_department}
                            </td>
                        </tr>
                        : null
                        }
                    </tbody>
                </Table>
            </div>
        </div>
    )
}

function ListUser(props){
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.company
    const notify = useContext(NotifyContext)
    const companyId = props.companyId
    const [userList ,setUserlist] = useState([])

    const [currentPage, setCurrentPage] = useState(1);
    const perPage = 6
    const totalPage = Math.ceil(userList.length / perPage)
    const indexOfLast = currentPage * perPage
    const indexOfFirst = indexOfLast - perPage
    const pageNumbers = []
    for(let i = 1; i<= totalPage; i++){
        pageNumbers.push(i)
    }

    const fetchUser = () =>{
        listUser("", companyId,
            (data)=>{
                setUserlist(data)
            },
            (error)=>{
                notify.showNotify("Something wrong", error.message, 2)
            })
    }

    useEffect(()=>{
        fetchUser()
    }, [])

    return(
        <div className="list-user">
            <div className="title-user">{lang.list_user}</div>
            <div className="company-section">
            <Table hover>
                <thead>
                    <tr>
                        <th></th>
                        <th>{lang.name}</th>
                        <th>{lang.email}</th>
                    </tr>
                </thead>
                <tbody>
                    { userList.slice(indexOfFirst, indexOfLast).map((item, key)=>
                    <tr key={key}>
                        <td className="profile">
                            { item.profileImagePath !== "" && item.profileImagePath !== null ?
                            <img src={item.profileImagePath} className="image" loading="lazy"/>
                            :
                            <FontAwesomeIcon icon={faUserCircle}/>
                            }
                        </td>
                        <td>{item.firstName + " " + item.lastName}</td>
                        <td>{item.email}</td>
                    </tr>
                    )}
                    { userList.length === 0 ?
                    <tr style={{textAlign: "center"}}>
                        <td colSpan={3}>{lang.no_user}</td>
                    </tr>
                    : null
                    }
                </tbody>
            </Table>
            </div>
            <div className="pagination">
                <TablePagination
                dataLength={totalPage}
                size={5}
                currentPage={currentPage}
                handlerPaginationClick={(page)=>{ setCurrentPage(page) }}
                nextClick={()=>{ setCurrentPage(currentPage + 1) }}
                prevClick={()=>{ setCurrentPage(currentPage - 1) }}
                firstPageClick={(first)=>{ setCurrentPage(first) }}
                lastPageClick={(last)=>{ setCurrentPage(last) }}
                disabledPrev={currentPage === indexOfFirst + 1}
                disabledNext={currentPage === totalPage}
                />
            </div>
        </div>
    )
}

export default CompanyDetail
